import { Fragment } from "react";
import { Menu, Transition } from "@headlessui/react";

export function DropDownButton(props) {
  const displayColorBG = () => {
    try {
      if (props != null) {
        return props.details.storeOptions.colorTheme.buttonColor;
      } else {
        return "#ff7979";
      }
    } catch (error) {
      console.log("error in display BG", error);
      return "#ff7979";
    }
  };
  console.log("displayColorBG()", displayColorBG());
  let activeButton = `inline-flex w-full justify-center gap-x-1.5 rounded-full  px-3 py-2 text-sm font-semibold text-gray-900 shadow-sm`;
  let inActiveButton =
    "inline-flex w-full justify-center gap-x-1.5 rounded-full bg-white px-3 py-2 text-sm font-semibold text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 hover:bg-gray-50";

  const didTapped = (item) => {
    try {
      props.reload(item, true);
    } catch (error) {
      console.log(error);
      alert("ops");
    }
  };
  const displayNew = (item) => {
    console.log(item);
    if (item === "VALENTINE'S 2025") {
      return (
        <span class="inline-flex items-center justify-center rounded-full border border-red-500 px-2.5 py-0.5 text-emerald-700">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            fill="none"
            viewBox="0 0 24 24"
            stroke-width="1.5"
            stroke="currentColor"
            class="-ms-1 me-1.5 size-4"
          >
            <path
              stroke-linecap="round"
              stroke-linejoin="round"
              d="M9 12.75L11.25 15 15 9.75M21 12a9 9 0 11-18 0 9 9 0 0118 0z"
            />
          </svg>
          <p class="whitespace-nowrap text-bold">New</p>
        </span>
      );
    }
  };

  let content = () => {
    try {
      return (
        <Menu as="div" className="relative inline-block text-left ml-2">
          <div className=" align-middle flex justify-center">
            <Menu.Button
              style={{ backgroundColor: displayColorBG() }}
              className={activeButton}
            >
              <span class="text-xs text-white">{props.mainTitle}</span>
              <svg
                xmlns="http://www.w3.org/2000/svg"
                fill="none"
                viewBox="0 0 24 24"
                stroke-width="1.5"
                stroke="white"
                class="w-4 h-4"
              >
                <path
                  stroke-linecap="round"
                  stroke-linejoin="round"
                  d="M19.5 8.25l-7.5 7.5-7.5-7.5"
                />
              </svg>
            </Menu.Button>
          </div>

          <Transition
            as={Fragment}
            enter="transition ease-out duration-100"
            enterFrom="transform opacity-0 scale-95"
            enterTo="transform opacity-100 scale-100"
            leave="transition ease-in duration-75"
            leaveFrom="transform opacity-100 scale-100"
            leaveTo="transform opacity-0 scale-95"
          >
            <Menu.Items className="absolute right-0 z-10 mt-2 w-56 origin-top-right rounded-md bg-white shadow-lg ring-1 ring-black ring-opacity-5 focus:outline-none">
              <div className="py-1">
                {props.items.map((item) => (
                  <Menu.Item key={item.key}>
                    {({ active }) => (
                      <a
                        onClick={() => didTapped(item, active)}
                        href="#"
                        className={`block px-4 py-2 text-sm ${active ? "bg-gray-100 text-gray-900" : "text-gray-700"}`}
                      >
                        {item.displayName}
                        {displayNew(item.displayName)}
                      </a>
                    )}
                  </Menu.Item>
                ))}
                {/* <Menu.Item>
                {({ active }) => (
                  <a
                  onClick={didTapped}
                    href="#"
                    className={classNames(
                      active ? 'bg-gray-100 text-gray-900' : 'text-gray-700',
                      'block px-4 py-2 text-sm'
                    )}
                  >
                    Dried Roses
                  </a>
                )}
              </Menu.Item>
              <Menu.Item>
                {({ active }) => (
                  <a
                    href="#"
                    className={classNames(
                      active ? 'bg-gray-100 text-gray-900' : 'text-gray-700',
                      'block px-4 py-2 text-sm'
                    )}
                  >
                    Support
                  </a>
                )}
              </Menu.Item>
              <Menu.Item>
                {({ active }) => (
                  <a
                    href="/cart"
                    className={classNames(
                      active ? 'bg-gray-100 text-gray-900' : 'text-gray-700',
                      'block px-4 py-2 text-sm'
                    )}
                  >
                    Dried Sunflower
                  </a>
                )}
              </Menu.Item>

                <Menu.Item>
                  {({ active }) => (
                    <button
                      type="submit"
                      className={classNames(
                        active ? 'bg-gray-100 text-gray-900' : 'text-gray-700',
                        'block w-full px-4 py-2 text-left text-sm'
                      )}
                    >
                      Sign out
                    </button>
                  )}
                </Menu.Item>
               */}
              </div>
            </Menu.Items>
          </Transition>
        </Menu>
      );
    } catch (error) {
      return null;
    }
  };
  return content();
}
